<template>
  <b-dropdown
    id="layer-selector"
    :position="position"
    v-model="checkedLayer"
    aria-role="list">
    <button
      class="button is-dark has-background-black-bis"
      type="button"
      slot="trigger">
      <span>{{ collection[checkedLayer].title }}</span>
      <b-icon icon="menu-down"></b-icon>
    </button>
    <b-dropdown-item
      v-for="(item, key) in collection"
      :value="key"
      :key="key"
      aria-role="listitem"
      @click="layerChanged">
      {{ item.title }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>

export default {
  props: {
    layers: {
      type: Object,
      default: null
    },
    activeLayer: {
      type: String,
      default: null
    },
    position: {
      type: String,
      default: null
    },
    onChange: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      collection: this.layers || {},
      checkedLayer: this.activeLayer || ''
    }
  },
  methods: {
    layerChanged () {
      this.onChange(this.checkedLayer)
    }
  }
}

</script>

<style lang="stylus" scoped>


</style>
